import classNames from 'classnames';
import React, { useMemo } from 'react';
import styles from './TabBar.module.css';

export type TabBarTabDefinition<T> = {
  key: T;
  label: string;
};
type Props<T> = {
  css?: Partial<{
    container: string;
    tab: string;
  }>;
  selectedTab: T;
  onTabSelected: (selectedTab: T) => void;
  tabs: TabBarTabDefinition<T>[];
};
export const TabBar = <T extends string>(props: Props<T>) => {
  const { selectedTab, onTabSelected, tabs, css } = props;

  return (
    <div className={classNames(css?.container, styles.container)}>
      {tabs.map(tab => (
        <div
          key={tab.key}
          className={classNames(css?.tab, styles.tab, {
            [styles.selectedTab]: tab.key === selectedTab,
          })}
          onClick={() => onTabSelected(tab.key)}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};
